/* Goloka V3 — product page read order: buttons → delivery card → pickup note.
   Dawn renders pickup-availability inside the buy-buttons block, above our
   delivery card; move it to sit right after the card. Re-applied when a
   variant change re-renders the block. */
(function () {
  function place() {
    document.querySelectorAll('.v3-pdp').forEach(function (pdp) {
      var trust = pdp.querySelector('.v3-trust');
      var pick = pdp.querySelector('pickup-availability');
      if (!trust || !pick || trust.nextElementSibling === pick) return;
      // Keep only one (a re-render can leave a fresh copy in the buy block).
      pdp.querySelectorAll('pickup-availability').forEach(function (p) { if (p !== pick) p.remove(); });
      trust.insertAdjacentElement('afterend', pick);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place); else place();
  new MutationObserver(function () { place(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
